(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draw-handler/client/create-jupiter-instance.js') >= 0) return;  svs.modules.push('/components/sport/draw-handler/client/create-jupiter-instance.js');
'use strict';

const {
  ApiProxy
} = svs.components.lbUtils.apiProxy;
const apiProxy = ApiProxy.create();
const createJupiterInstance = () => async function () {
  return apiProxy.fetch(...arguments);
};
setGlobal('svs.components.sport.drawHandler.client.createJupiterInstance', createJupiterInstance);

 })(window);